<template>
  <div class="page-content">
    <!--<div class="container">-->
    <div class="">
      <div
        class="sample1 grid middle"
        @keyup.46="$bvModal.show('confirmDeleteData')"
      ></div>
      <div class="row gridBtGroup rowItem" xl="1" lg="3" md="3" sm="3">
        <img
          src="@/assets/excluir.png"
          :alt="$t('excluir')"
          style="margin-left: 30px; height=38px"
          :title="$t('excluir')"
          @click="$bvModal.show('confirmDeleteData')"
        />
        <img
          src="@/assets/salvar.png"
          :alt="$t('salvar')"
          style="margin-left: 30px; height=38px"
          :title="$t('salvar')"
          @click="sendProducts()"
        />
        <img
          src="@/assets/cancel.png"
          :alt="$t('cancelar')"
          style="margin-left: 30px; height=38px"
          :title="$t('cancelar')"
          @click="$bvModal.show('confirmResetData')"
        />
      </div>
    </div>
    <b-modal
      id="confirmResetData"
      :title="$t('atencao')"
      ok-variant=danger
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="reset"
      >{{ $t('confirma-o-descarte-das-alteracoes-1') }}</b-modal
    >
    <b-modal
      id="confirmDeleteData"
      :title="$t('atencao')"
      ok-variant=danger
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="del"
      >{{ $t('deseja-excluir-os-produtos-selecionados') }}</b-modal
    >

    <b-modal
      id="DeletionNotAllowed"
      size="md"
      hide-footer
      :title="$t('alerta')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        :info="deletionNotAllowed"
        modelname="DeletionNotAllowed"
      />
    </b-modal>

  </div>
</template>

<script>
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { defaultSuccess, urlMainAPI } from "@/global";
import MessageBox from "@/components/template/MessageBoxModal.vue";
import axios from "axios";

var inputEditor = new cheetahGrid.columns.action.InlineInputEditor();

inputEditor.disabled = (record) => {
  if (record != null || record != undefined) {
    return false;
  }
};

const { CLICK_CELL, PASTE_CELL, INPUT_CELL } = cheetahGrid.ListGrid.EVENT_TYPE;

export default {
  description: "GridProducts",
  components: {
    ...cGridAll,
    MessageBox
  },
  watch: {
    json() {},
  },
  data: function () {
    return {
      temp: [],
      grid: "",
      currentLine: 0,
      json: [],
      deletionNotAllowed: "",
      header: [
        {
          field: "description",
          caption:this.$t('produtos'),
          action: inputEditor,
          width: "98%",
          maxWidth: "98%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
        },
      ],
    };
  },
  methods: {
    loadProducts() {
      defaultSuccess(this.$t('carregando-produtos'));
      const url = `${urlMainAPI}/getproducts`;
      axios
        .get(url)
        .then((res) => {
          this.json = res.data.length == 0 ? [{ description: "" }] : res.data;
          this.temp = JSON.parse(JSON.stringify(this.json));
          this.addLine();
          this.setGrid();
          defaultSuccess(this.$t('produtos-carregados'));
        })
        .catch();
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".sample1"),
        allowRangePaste: true,
        header: this.header,
      });
      grid.records = this.json;
      grid.listen(INPUT_CELL, (...args) => {
        if (
          args[0].row == this.json.length &&
          !this.json[this.json.length - 1].description
        ) {
          this.addLine();
          this.setGrid();
        }
      });

      grid.listen(CLICK_CELL, (...args) => {
        this.currentLine = args[0].row;
        let hasData = this.json[this.json.length - 1].description ?
                      this.json[this.json.length - 1].description.trim() ?
                      true :
                      false :
                      false;

        if (args[0].row == this.json.length && hasData) {
          this.addLine();
          this.setGrid();
        }
      });

      grid.listen(PASTE_CELL, async (...args) => {
        let lines = args[0].normalizeValue.split("\r\n");
        let temp2 = lines;
        let countTable = this.json.length;
        if (this.currentLine == 1) {
          if (countTable < lines.length) {
            let dif = lines.length - countTable;
            for (let i = 0; i <= dif; i++) {
              this.addLine(lines[countTable + i]);
            }
          }
        } else if (
          this.currentLine == this.json.length ||
          this.currentLine == this.json.length - 1
        ) {
          this.clearEmptyLines();
          let calc = temp2.length + (this.json.length - this.currentLine);
          for (let i = 0; i <= calc; i++) {
            this.addLine(temp2[i]);
          }
          this.addLine();
        }
        this.setGrid();
      });

      this.setGrid = function (table = this.json) {
        grid.records = table;
      };

      this.json = grid.records;
      this.grid = grid;
    },

    clearEmptyLines() {
      let count = this.json.length - this.currentLine + 1;
      for (let i = 0; i < count; i++) this.json.pop();
    },

    addLine(param) {
      this.json.push({ id: "", description: param });
    },

    async sendProducts() {
      defaultSuccess(this.$t('salvando-dados'));
      let productList = await this.json.map((d) => {
        if (d.id)
          return { id: d.id, description: d.description };
        return { id: 0, description: d.description };
      });

      const url = `${urlMainAPI}/saveproducts`;
      await axios
        .post(url, productList)
        .then((res) => {
          this.json = res.data;
          this.temp = JSON.parse(JSON.stringify(this.json));
          defaultSuccess(this.$t('produtos-salvo-com-sucesso'));
        })
        .catch();

        this.setGrid();
    },

    reset() {
      this.json = JSON.parse(JSON.stringify(this.temp));
      this.setGrid(this.json);
      defaultSuccess(this.$t('alteracoes-descartadas'));
    },

    del() {
      let indexFirstElement = this.grid.selection._start.row - 1;
      let productsToDelete = this.json.slice(
        indexFirstElement,
        this.grid.selection._end.row
      );

      productsToDelete = productsToDelete.map(p => {
        if (p.id == '') {
          return { id: 0, description: p.description }
        }
        return p
      })

      const url = `${urlMainAPI}/deleteproducts`;

      axios
        .post(url, productsToDelete)
        .then(async (res) => {
          let productsNotDelete = res.data.productsNotDelete;
          if (productsNotDelete.length > 0) {
            let text = `O(s) produto(s):`;
            productsNotDelete.forEach((prod) => {
              text += ` ${prod.description == '' ? '[vazio]' : prod.description}; `; 
            });
            text += `não pode(m) ser removido(s),`
            text += ` pois possui(em) configuração de grandeza ou gatilhos de ocorrências.`;
            this.deletionNotAllowed = text;
            this.$bvModal.show("DeletionNotAllowed");
          } else {
            defaultSuccess(this.$t('produto-s-removidos-com-sucesso'));
          }
          await this.removeDeletedProducts(productsToDelete, productsNotDelete);
        })
        .catch();
    },

    async removeDeletedProducts(productsToDelete, productsNotDelete) {
      let remove = new Array();
      await productsToDelete.forEach((p) => {
        let pFounded = productsNotDelete.find((p2) => p2.id == p.id);
        if (pFounded == null) remove.push(p);
      });
      remove.forEach((p) => {
        let index = this.json.findIndex((p2) => p2.id == p.id);
        this.json.splice(index, 1);
      });
      this.temp = JSON.parse(JSON.stringify(this.json));
      // this.$bvModal.show("DeletionNotAllowed");
      this.setGrid();
    },
  },

  created() {
    this.loadProducts();
  },

  mounted() {
    this.createGrid();
  },
};
</script>

<style scoped>
.grid {
  width: 80vw;
  height: calc(80vh - 220px);
  /* width: 100%; */
  border: solid 1px rgba(0, 0, 0, 0.26);
  margin: 30px auto auto auto;
  overflow-x: hidden;
  overflow-y: auto;
}

.row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  /* margin-right: 70px; */
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.gridBtGroup {
  margin: 30px auto auto auto;
  width: 80vw;
  display: flex;
  justify-content: flex-end;
}

.ybase {
  /* margin-right: 20px; */
  margin-top: 20x;
}

.gridBtGroup img {
  cursor: pointer;
  max-height: 45px;
}

/* @media only screen and (max-width: 1247px) {
  .grid {
    width: 88%;
  }
} */
</style>